import { ThunkType } from "../../../../core/store/reducers";
import getDividends from "../api/getdividendlist";
import { PageDataStatus, PageData } from "../../../models";
import { DividendFilter, DividendList } from "../types";

export const getDividendsThunk = (
	pageNumber?: number,
	itemsPerPage?: number,
	filter?: DividendFilter
): ThunkType<Promise<PageData<DividendList> | undefined>> => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return undefined;
	}

	const user = store.data.auth.current.user;

	const dividendsData = await dispatch(getDividends(user, pageNumber, itemsPerPage, filter));

	if (!dividendsData || dividendsData.resCode !== "OK") {
		return undefined;
	}

	return {
		currentPageData: dividendsData.obj,
		totalCount: Number(dividendsData.resDesc) || 0,
		status: PageDataStatus.DataCurrent,
	};
};
